import { createSelector } from 'reselect'

import viewTypes from 'helpers/enums/viewTypes'
import modalTypes from 'helpers/enums/modalTypes'

const uiSelector = state => state.ui
const modalSelector = state => state.modal
const oeqActivitySelector = state => state.oeq
const drawItActivitySelector = state => state.drawIt
const collaborateActivitySelector = state => state.collaborate

const cancelSlideSelector = createSelector(
	[
		uiSelector,
		modalSelector,
		oeqActivitySelector,
		drawItActivitySelector,
		collaborateActivitySelector,
	],
	(
		ui,
		modals,
		oeqActivityState,
		drawItActivityState,
		collaborateActivityState,
	) => {
		let activityState = {}

		switch (ui.currentView) {
			case viewTypes.QUICK_LAUNCH_OEQ_ACTIVITY_CREATION:
				activityState = oeqActivityState
				break
			case viewTypes.QUICK_LAUNCH_DRAW_IT_ACTIVITY_CREATION:
				activityState = drawItActivityState
				break
			default:
				if (
					modals[0].modalName === modalTypes.QUICK_LAUNCH_COLLABORATE_CREATE
				) {
					activityState = collaborateActivityState
				}
				break
		}

		return activityState
	}
)

export default cancelSlideSelector
